export interface RequestAssistanceDto {
    message: string,
    file?: any,
}

export const requestAssistanceInit: RequestAssistanceDto = { message: '' };